import * as params from "./params"
import * as d3 from "d3"
import { AbsoluteCropParameters, PartialAbsoluteCropParameters } from "app/helpers/CropHelper"

export const append = (svgElement) => {
  if (svgElement.selectAll("#dashboard-background").size() > 0) {
    return
  }
  const bgSvg = svgElement
    .append("svg")
    .attr("id", "dashboard-background")
    .classed("dashboard-background", true)
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", params.width)
    .attr("height", params.height)
    .style("display", "none")

  bgSvg
    .append("image")
    .attr("id", "dashboard-background-image")
    .classed("dashboard-background", true)
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", params.width)
    .attr("height", params.height)
    .attr("data-media-id", "")
    .attr("href", "")

  bgSvg
    .append("rect")
    .attr("id", "dashboard-background-image-tint")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", params.width + 10)
    .attr("height", params.height + 10)
    .style("opacity", "0")

  bgSvg.lower()
}

export const setCrop = (crop?: PartialAbsoluteCropParameters) => {
  d3.selectAll("#dashboard-background-image")
    .attr("x", `${crop ? (-crop.x / crop.width) * params.width : 0}`)
    .attr("y", `${crop ? (-crop.y / crop.height) * params.height : 0}`)
    .attr("width", `${crop ? 1600 / crop.width : 1600}`)
    .attr("height", `${crop ? 900 / crop.height : 900}`)
}

export const getCrop = (): AbsoluteCropParameters | undefined => {
  const image = d3.select("#dashboard-background-image")
  if (image.size()) {
    return {
      width: Number(image.attr("width") || params.width),
      height: Number(image.attr("height") || params.height),
      x: Number(image.attr("x") || "0"),
      y: Number(image.attr("y") || "0"),
      imgWidth: params.width,
      imgHeight: params.height,
    }
  } else {
    return undefined
  }
}

export const setImage = (href?: string, mediaId?: string) => {
  setCrop(undefined)
  if (href) {
    const image = d3.selectAll("#dashboard-background-image").attr("href", href)
    if (mediaId) {
      image.attr("data-media-id", mediaId)
    }
    d3.selectAll("#dashboard-background").style("display", "inline")
  } else {
    d3.selectAll("#dashboard-background-image").attr("href", null).attr("data-media-id", null)
    d3.selectAll("#dashboard-background").style("display", "none")
  }
}

export const getImage = (): { url?: string; mediaId?: string } => {
  const image = d3.select("#dashboard-background-image")
  if (image.size()) {
    return { url: image.attr("href"), mediaId: image.attr("data-media-id") }
  } else {
    return {}
  }
}

export const isEnabled = () => {
  const background = d3.select("#svg-dashboard")?.selectAll("#dashboard-background")
  return background?.size() && background?.style("display") === "inline"
}

export type ImageTintMode = "dark" | "light" | "none"
export const setImageTint = (mode: ImageTintMode) => {
  const backgroundImageTint = d3.select("#dashboard-background-image-tint")
  if (backgroundImageTint.size()) {
    switch (mode) {
      case "dark": {
        backgroundImageTint.style("opacity", "0.7")
        backgroundImageTint.attr("fill", "black")
        break
      }
      case "light": {
        backgroundImageTint.style("opacity", "0.25")
        backgroundImageTint.attr("fill", "white")
        break
      }
      case "none": // falls through
      default: {
        backgroundImageTint.style("opacity", "0")
        backgroundImageTint.attr("fill", null)
      }
    }
  }
}

export const getImageTint = (): ImageTintMode => {
  const backgroundImageTint = d3.select("#dashboard-background-image-tint")
  if (backgroundImageTint.size()) {
    if (backgroundImageTint.attr("fill") === "black") {
      return "dark"
    }
    if (backgroundImageTint.attr("fill") === "white") {
      return "light"
    }
  }
  return "none"
}
